import { render, staticRenderFns } from "./ScreenConfigureNotifications.vue?vue&type=template&id=4dec45a7&scoped=true"
import script from "./ScreenConfigureNotifications.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec45a7",
  null
  
)

export default component.exports